import { render, staticRenderFns } from "./Tablet.vue?vue&type=template&id=415212f8&scoped=true&"
import script from "./Tablet.vue?vue&type=script&lang=ts&"
export * from "./Tablet.vue?vue&type=script&lang=ts&"
import style0 from "./Tablet.vue?vue&type=style&index=0&id=415212f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415212f8",
  null
  
)

export default component.exports